import { createSlice } from '@reduxjs/toolkit'

import { AuthState } from './auth.type'

const initialState: AuthState = {
  loading: false,
  accessToken: '',
  user: null,
  privateKey: '',
  idUser: '',
  socialRedirect: '',
  redirectInvite: '',
  pointInviteCode: null,
  inviteCode: '',
  loginMethod: '',
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setToken: (state, action) => {
      state.accessToken = action.payload
    },
    setUser: (state, action) => {
      state.user = action.payload
    },
    setPrivateKey: (state, action) => {
      state.privateKey = action.payload
    },
    setIdUser: (state, action) => {
      state.idUser = action.payload
    },
    setSocialRedirect: (state, action) => {
      state.socialRedirect = action.payload
    },
    setRedirectInvite: (state, action) => {
      state.redirectInvite = action.payload
    },
    logout: (state) => {
      state.accessToken = ''
      state.user = null
      localStorage.clear()
      document.cookie.split(';').forEach((cookie) => {
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      })

      // window.location.reload();
    },
    setPointInviteCode: (state, action) => {
      state.pointInviteCode = action.payload
    },
    resetLocalSocial: (state) => {
      if (state.user) {
        state.user.socials = []
      }
    },
    setLocalSocial: (state, action) => {
      if (state.user) {
        state.user.socials = action.payload
      }
    },
    setInviteCode: (state, action) => {
      state.inviteCode = action.payload
    },
    setLoginMethod: (state, action) => {
      state.loginMethod = action.payload
    },
  },
  extraReducers: () => {},
})

export const authActions = authSlice.actions
const authReducer = authSlice.reducer
export default authReducer
